import { useTheme } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import GestarWhiteLogo from '../../vectors/gestarWhiteLogo';
import CampusVirtual from '../header/headerComps/campusVirtual/campusVirtual';
import SocialMedia from '../SocialMedia/socialMedia';
import { CONTACT_DATA, GESTAR_NAV, MODES_FOOTER } from '../../utils/constants';
import { Link } from 'react-router-dom';
import '../../App.css'
import MenuCustom from '../menuCustom/menuCustom';
import { useAppContext } from '../../App';
import { scrollTop } from '../../utils/functions';
import { getModes } from '../../utils/dataFetch';

export default function Footer() {
  const theme = useTheme();
  const {isMobile, categoryItems, setSelectedCategory, setAppType} = useAppContext();
  const [modes, setModes] = useState([]);
  const style = styles(theme, isMobile);

  const generalCategoriesRoutes = [
    'categorias-general/Cursos',
    'categorias-general/Trayecto Profesional',
    'categorias-general/Secretariados',
    'in-company', 'comunidad', 'sobre-nosotros'
  ]

  useEffect(()=>{
    getModes().then(setModes)
  },[]);
  
  return (
    <div style={style.container} className="sansation-bold">
      <div style={{ display: "flex", flexDirection: isMobile? "column" : "row" }}>
      <div style={style.leftContainer}>
  <Link to={'/'} onClick={scrollTop}>
    <GestarWhiteLogo
      viewBox={"270 220 500 200"}
      style={style.whiteLogo}
    />
  </Link>
  <CampusVirtual customStyles={style.campus} />
  <SocialMedia customStyles={style.socialMedia} />
    <Link to="/politica-devoluciones" style={style.devolucionesLink}>
    Política de Devoluciones y Derecho de Arrepentimiento
  </Link>
</div>
        <div style={style.mainManu}>
          <MenuCustom
            id={'categorias-footer'}
            title={'CATEGORIAS'}
            customActionOnItemclick={() => setSelectedCategory(null)}
            titleRedirectTo={`/categorias-general/Cursos`}
            addItemToPath={true}
            itemRedirectTo='/categorias-general/Cursos'
            items={categoryItems}
            customStyles={{
              title:{
                color: theme.color.text.tertiary
              }
            }}
          />
        </div>
        <div style={{...style.mainManu, width: isMobile? '50%':'30%'}}>
          <MenuCustom
            id={'menu-modalidad-footer'}
            title={'MODALIDAD'}
            itemRedirectTo={'/categorias-general/Cursos'}
            items={modes.map(item => ({
              name: item.name,
              modalidad: item.id
            }))}
            customStyles={{
              title:{
                color: theme.color.text.tertiary
              }
            }}
            customActionOnItemclick={() => setSelectedCategory(null)}
          />
          <Link style={style.professionalPath} to={'/trayectoria'} onClick={() => {setAppType('Cursos'); scrollTop();}} >
            TRAYECTO PROFESIONAL
          </Link>
        </div>
        <div style={{...style.mainManu, width: isMobile? '50%':'25%'}}>
          <MenuCustom
            id={'menu-gestar-footer'}
            title={'GESTAR'}
            items={GESTAR_NAV.map(item => ({name: item}))}
            itemRedirectTo=''
            addItemToPath={true}
            routesForItems={generalCategoriesRoutes}
            customStyles={{
              title:{
                color: theme.color.text.tertiary
              }
            }}
            customActionOnItemclick={() => setSelectedCategory(null)}
          />
        </div>
        <div style={{...style.mainManu, width: isMobile? '50%':'25%'}}>
          <MenuCustom
            id={'contacto-footer'}
            title={'CONTACTO'}
            itemRedirectTo={''}
            items={CONTACT_DATA.map(item => ({name: item}))}
            customStyles={{
              title:{
                color: theme.color.text.tertiary
              }
            }}
          />
        </div>
      </div>
      <div style={style.finalQuote}>
        GestarEducativa ® es una Compañía Online registrada en Argentina -
        Servicios a países Latinoamericanos | Copyright © 2024
      </div>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: '5vw',
    paddingRight: '5vw',
    backgroundColor: theme.background.secondary
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "4vh",
    paddingBottom: "2vh"
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  whiteLogo: {
    width: "20rem",
    height: "5rem",
  },
  campus: {
    container: {
      display: "flex",
      justifyContent: "space-around",
      width: "70%",
      marginLeft: 0,
      backgroundColor: theme.background.primary
    },
    round:{
      backgroundColor: theme.background.secondary
    }
  },
  socialMedia:{
    container: {
      marginTop: '10%',
    }
  },
  finalQuote: {
    padding: '2vh',
    borderTopColor: "grey",
    borderTopWidth: 1,
    textAlign: "center",
    color: theme.color.text.primary
  },
  mainManu:{
    width: isMobile? "100%":'70%',
    marginTop: "4vh",
    marginBottom: "1vh",
    marginLeft: "1vh"
  },
  professionalPath:{
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    maxWidth: '90%',
    marginTop: '5%',
    marginBottom: '3%',
    paddingTop: '3%',
    paddingBottom: '3%',
    color: theme.color.text.primary,
    backgroundColor: theme.background.primary,
  },
  devolucionesLink: {
  marginTop: '1rem',
  color: theme.color.text.primary,
  fontSize: '0.9rem',
  textDecoration: 'underline',
  textAlign: 'center',
}

});